var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoresActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB5800",
    d: "M18.001,11.417L14.084,7.5l-4,5L7.001,9.417l-1.586,1.585H2.001v9c0,1.104,0.897,2,2,2h16 c1.103,0,2-0.896,2-2v-11h-1.586L18.001,11.417z M7.001,20.002h-2v-3h2V20.002z M11.001,20.002h-2v-5h2V20.002z M15.002,20.002h-2 v-3h2V20.002z M19.002,20.002h-2v-5h2V20.002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M20.001,2.002h-16c-1.103,0-2,0.897-2,2v5h2.586l2.414-2.414l2.917,2.917l4-5l4.083,4.083l1.586-1.586h2.414 v-3C22.001,2.899,21.104,2.002,20.001,2.002z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoresActive);
export default __webpack_public_path__ + "static/media/scores_active.3f4ca4cc.svg";
export { ForwardRef as ReactComponent };